"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgKey02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 9a7 7 0 1 1 6.06 6.937 14.332 14.332 0 0 0-.514-.063l-.01.01a8.942 8.942 0 0 0-.25.244l-5.11 5.11-.036.037a2.794 2.794 0 0 1-.51.43c-.178.11-.373.19-.577.24a2.795 2.795 0 0 1-.665.055h-1.82c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C2 19.93 2 19.684 2 19.432v-1.82c0-.19-.001-.43.055-.665.05-.204.13-.399.24-.578.126-.206.296-.375.43-.509l.036-.036 5.111-5.11c.126-.126.196-.197.245-.25l.008-.01-.003-.045c-.01-.103-.03-.244-.06-.469A7.056 7.056 0 0 1 8 9Zm7 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z", fill: "currentColor" }) }))); };
exports.default = SvgKey02;
